import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIpfsComponent } from './simple-icons-ipfs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIpfsComponent ],
    exports:      [ SimpleIconsIpfsComponent ],
    bootstrap:    []
})
export class SimpleIconsIpfsModule {}
